// Tag relevance-archiving client — talks to the api-service routes
// `PUT /api/ontology/tags/archive` (mark one tag archived / not relevant).
// Server-side the flag rides the standard tri-state
// `valid` field on the graph `:Tag` node: `valid = false` means
// archived; unarchiving re-validates with `valid = true`. Inventory reads
// return the current flag with each graph row, so callers do not need a
// second full-namespace readback.

import { getOntologyServiceBaseUrl } from '../../config'
import { createOntologyHeaders } from '../core'
import { invalidateTagInventoryQueryCache } from './tag-inventory'

async function requestJson<T>(method: 'POST' | 'PUT', path: string, body: unknown): Promise<T> {
  const resp = await fetch(`${getOntologyServiceBaseUrl()}${path}`, {
    method,
    headers: createOntologyHeaders(),
    body: JSON.stringify(body)
  })
  if (!resp.ok) {
    let message = `${resp.status} ${resp.statusText}`
    try {
      const errBody = (await resp.json()) as { error?: unknown }
      if (typeof errBody.error === 'string') message = errBody.error
    } catch {
      // keep the status-line message
    }
    throw new Error(message)
  }
  return (await resp.json()) as T
}

/** Mark one tag as archived (not relevant) or unarchive it. */
export async function setTagArchived(nodeId: string, archived: boolean): Promise<void> {
  await requestJson('PUT', '/tags/archive', { node_id: nodeId, archived })
  // Archiving changes the graph rows every inventory view renders.
  invalidateTagInventoryQueryCache()
}
